<template>
  <div class="no-padding">

    <memlist-modal ref="editor-modal" size="lg">
      
      <form ref="form" @submit.prevent="on_submit" class="mt-8">
        <m-row>
          <m-col cols="12">
            <memlist-select-input2
              v-model="audience_id"
              :items="audience_options"
              :title="$t('AUDIENCE.AUDIENCE')"
              layout="vertical"
              size="sm"
              validation_type="TEXT"
            />
          </m-col>
        </m-row>

        <p style="margin-top: 42px;"></p>

        <m-row class="mt-4">
          <m-col lg="12">
            <RightModalSaveAndCloseButtons
              :text="$t('COMMON.SAVE')"
              :spin="true"
              @clicked="on_submit"
              @close="close_clicked"
              ref="saveButton"
            />
          </m-col>
        </m-row>
      </form>

    </memlist-modal>
  </div>
</template>


<script>
import { useVuelidate } from '@vuelidate/core'
import { minLength, required, email, requiredIf } from '@vuelidate/validators';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';


import axios from 'axios';
import dayjs from 'dayjs';

import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';

export default {

  name: 'MemberAudienceEditorModal',

  props: ['search_options'],
  emits: ['created', 'cancel'],
  mixins: [ toasts ],

  components: {
    RightModalSaveAndCloseButtons,
  },

  watch: {
    
  },


  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies', 'periods', 'settings']),

    disabledCreateButton() {
      return !this.local_item.audience_id;
    }
  },


  mounted() {
    
  },

  methods: {

    close_clicked() {
      this.$refs['editor-modal'].hide();
    },
    hide() {
      this.$refs['editor-modal'].hide();
    },
    show() {
      this.load_audience();
      this.$refs['editor-modal'].show();
    },

    validate_state(state) {
      return state.dirty ? !state.error : null;
    },

    async load_audience() {
      const res = await axios.get(`/audience`);

      if (res.status === 200) {
        this.audience_options = res.data.map(i => ({ text: i.name, value: i.id }));
      }
      
    },

    async on_submit() {

      if (this.audience_id) {
        await this.assign_search_to_audience(this.audience_id, this.search_options);
      }

    },


    async assign_search_to_audience(audience_id, search_options) {
      try {

        const res = await axios.post(`/audience/${audience_id}/assign/search`, { search_options });

        if (res.status === 201) {
          this.$refs['saveButton'].stop();

          this.$emit('created');
        }
        else if (res.status === 403) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.PERMISSION_DENIED'));
          this.$refs['saveButton'].stop();
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('AUDIENCE.UNABLE_CREATE_MEMBER'));
          this.$refs['saveButton'].stop();
        }
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('AUDIENCE.UNABLE_CREATE_MEMBER'));
        this.$refs['saveButton'].stop();
      }
    },

    async save_data() {

      this.$emit('save_data', this.local_item);

    },
  },

  data() {
    return {
      audience_id: null,
      audience_options: [],
    };
  }
};

</script>

